'use strict';

const _=require('pulsar-utils/dist-es6/_');
const approximateNumber=require('approximate-number');
const Formatters=require('../../../../dist-es6/client/formatters');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ThresholdStatusSummaryDirective=class ThresholdStatusSummaryDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['itemsByThresholdStatus'];
}

get textBindings(){
return['itemLabel'];
}

get templateUrl(){
return'/templates/directives/thresholdStatusSummaryDirective/thresholdStatusSummaryTemplate';
}

get controller(){
return ThresholdStatusSummaryController;
}};let


ThresholdStatusSummaryController=class ThresholdStatusSummaryController{
static get $inject(){
return['$scope','$timeout'];
}

constructor($scope,$timeout){
this._$scope=$scope;
this._$timeout=$timeout;

this.mode='total';
this.itemLabel=this.itemLabel||'Event';

this._$scope.$watch('controller.itemsByThresholdStatus',(itemsByStatus,oldItemsByStatus)=>{
if(this.totalAll&&_.exists(oldItemsByStatus)&&itemsByStatus===oldItemsByStatus){
return;
}

this._updateMetrics(this.itemsByThresholdStatus);
});

this._updateMetrics();
}

_updateMetrics({At=[],Above=[],Below=[],NotApplicable=[]}={}){
this._$timeout(()=>{
this.totalUnder=Below.length+NotApplicable.length;
this.totalNear=At.length;
this.totalOver=Above.length;
this.totalAll=this.totalUnder+this.totalNear+this.totalOver;

this.percentNear=_getCleanPercentage(this.totalNear,this.totalAll);
this.percentOver=_getCleanPercentage(this.totalOver,this.totalAll);

if(this.totalAll!==0){
const remainingPercent=Math.round(100-_.sum([
this.percentNear.startsWith('<')?0.5:parseInt(this.percentNear,10),
this.percentOver.startsWith('<')?0.5:parseInt(this.percentOver,10)]));


this.percentUnder=`${remainingPercent}%`;
}else{
this.percentUnder='--';
}

this.formattedTotalUnder=approximateNumber(this.totalUnder);
this.formattedTotalNear=approximateNumber(this.totalNear);
this.formattedTotalOver=approximateNumber(this.totalOver);
this.formattedTotalAll=approximateNumber(this.totalAll);
});
}};


function _getCleanPercentage(num,total,roundMethod='round'){
if(total===0){
return'--';
}else if(num===0){
return'0%';
}

const realPercent=num/total*100;
const amountLabel=realPercent<1?
'<1':
Math[roundMethod](realPercent);

return`${amountLabel}%`;
}


module.exports=ThresholdStatusSummaryDirective;
//# sourceMappingURL=thresholdStatusSummaryDirective.js.map
